import { render, staticRenderFns } from "./homeNav.vue?vue&type=template&id=08536170"
import script from "./homeNav.vue?vue&type=script&lang=js"
export * from "./homeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports